import React, { useState, useEffect } from "react";
import MegaMenu from "./MegaMenu";
import "../aseets/css/Navbar2.css";
import gmlogo from "../aseets/gallery/GM_logo.png";
import insta from "../aseets/gallery/instagram.png";
import fb from "../aseets/gallery/fb.png";
import linkedin from "../aseets/gallery/linkedin.png";
import { Link } from "react-router-dom";

const Navbar2 = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleMenu = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "auto";
  }, [mobileOpen]);

  return (
    <>
      {/* TOP BAR */}
      <div className="top-bar">
        <div className="top-right">
          <img src={insta} alt="instagram" />
          <img src={fb} alt="facebook" />
          <img src={linkedin} alt="linkedin" />
        </div>
      </div>

      {/* MAIN NAV */}
      <nav className="main-nav">
        <div className="nav-left">
          <Link to="/" className="logo">
            <img src={gmlogo} alt="Global Manch" />
          </Link>

          {/* DESKTOP MENU */}
          <ul className="menu desktop-menu">
            <li onClick={() => toggleMenu("products")}>Services ▾</li>
            <li onClick={() => toggleMenu("pricing")}>Pricing ▾</li>
            <li onClick={() => toggleMenu("resources")}>Resources ▾</li>
            <li onClick={() => toggleMenu("company")}>Company ▾</li>
            <li><Link to="/about-us">About Us</Link></li>
            <li><Link to="/career">Career</Link></li>
          </ul>
        </div>

        <div className="nav-right">
          <Link to="/contact-us">
            <button className="btn outline">Contact Us</button>
          </Link>

          {/* HAMBURGER */}
          <div
            className={`hamburger ${mobileOpen ? "active" : ""}`}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <span />
            <span />
            <span />
          </div>
        </div>
      </nav>

      {/* MEGA MENU (DESKTOP ONLY) */}
      {activeMenu && (
        <MegaMenu type={activeMenu} onClose={() => setActiveMenu(null)} />
      )}

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${mobileOpen ? "open" : ""}`}>
        <ul>
          <li><Link to="/" onClick={() => setMobileOpen(false)}>Home</Link></li>
          <li><Link to="/about-us" onClick={() => setMobileOpen(false)}>About Us</Link></li>
          <li><Link to="/career" onClick={() => setMobileOpen(false)}>Career</Link></li>
          <li><Link to="/contact-us" onClick={() => setMobileOpen(false)}>Contact</Link></li>

          <li className="mobile-section">Services</li>
          <li className="sub">Digital Marketing</li>
          <li className="sub">SEO</li>
          <li className="sub">Performance Marketing</li>
          <li className="sub">Web Development</li>

          <li className="mobile-section">Resources</li>
          <li className="sub">Blogs</li>
          <li className="sub">Case Studies</li>
        </ul>
      </div>

      {/* MOBILE OVERLAY */}
      {mobileOpen && (
        <div className="mobile-overlay" onClick={() => setMobileOpen(false)} />
      )}
    </>
  );
};

export default Navbar2;
